import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function AboutUs() {
  const [aboutData, setAboutData] = useState(null);
  const [baseUrl, setBaseUrl] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchAboutData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/getAboutUs`);
      setAboutData(res.data.data);
      setBaseUrl(res.data.base_url);
    } catch (err) {
      console.error("Error fetching About Us data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <section className="ser_v_araeea allpages aboutuspages">
        <div className="container">
          <Skeleton count={10} height={20} style={{ marginBottom: "10px" }} />
        </div>
      </section>
    );
  }

  if (!aboutData) return null;

  return (
    <section className="ser_v_araeea allpages aboutuspages">

      <SetMetaTags
        title={aboutData?.meta_title}
        description={aboutData?.meta_description}
        keywords={aboutData?.meta_keyword}
      />
      <div className="container">

        {/* ===== Section 1: Destination ===== */}
        <div className="al_top_areass">
          <div className="tilss">
            <h2>{aboutData.title1}</h2>
          </div>
          <div className="diss_tilss">
            <p>{aboutData.description1}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8 col-sm-6">
            <div className="ab_mg_bg">
              <img
                src={`${baseUrl}${aboutData.image1}`}
                alt={aboutData.title1}
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-lg-4 col-sm-4">
            <div className="ab_mg_bg">
              <img
                src={`${baseUrl}${aboutData.image2}`}
                alt={aboutData.title1}
                className="img-fluid"
              />
            </div>
          </div>
        </div>

        {/* ===== Section 2: Who We Are ===== */}
        <div className="al_top_areass otherss">
          <div className="tilss">
            <h2>{aboutData.title2}</h2>
          </div>

          <div className="diss_tilss">
            <p>{aboutData.description2}</p>

            <h5>{aboutData.title3}</h5>
            <p>{aboutData.description3}</p>
          </div>
        </div>

        {/* ===== Section 3: What We Offer ===== */}
        <div className="ab_item_bx">
          <div className="allpages">
            <h2 className="text-left">{aboutData.title4}</h2>
          </div>

          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="itm_bx_areeaa">
                <div className="itm_bx_btomss">
                  <h4>{aboutData.sub_title1}</h4>
                  <p>{aboutData.sub_description1}</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="itm_bx_areeaa">
                <div className="itm_bx_btomss">
                  <h4>{aboutData.sub_title2}</h4>
                  <p>{aboutData.sub_description2}</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="itm_bx_areeaa">
                <div className="itm_bx_btomss">
                  <h4>{aboutData.sub_title3}</h4>
                  <p>{aboutData.sub_description3}</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="itm_bx_areeaa">
                <div className="itm_bx_btomss">
                  <h4>{aboutData.sub_title4}</h4>
                  <p>{aboutData.sub_description4}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== Section 4: Why We Started ===== */}
        <div className="al_top_areass otherss">
          <div className="tilss">
            <h2>{aboutData.title5}</h2>
          </div>

          <div className="diss_tilss">
            <p>{aboutData.description5}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="ab_mg_bg">
              <img
                src={`${baseUrl}${aboutData.image5}`}
                alt={aboutData.title5}
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;








// import axios from "axios";
// import { useEffect, useState } from "react";
// import Skeleton from "react-loading-skeleton";

 
// function AboutUs() {

// 	const [aboutDestination, setAboutDestination] = useState(null);
// 	const [aboutWho, setAboutWho] = useState(null);
// 	const [aboutWhatoffer, setAboutwhatoffer] = useState(null);
// 	const [aboutAboutstarted, setAboutstarted] = useState(null);
// 	const [loading, setLoading] = useState(true);

// 	const fetchAboutData = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API_BASE}/getAboutUs`);
//       setAboutDestination(res.data.data);
//     } catch (err) {
//       console.error("Error fetching cancellation policy:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

 

   

  

// 	useEffect(() => {
// 			window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // ya "auto"
// 			fetchAboutData();
			
// 		  }, []);
//   return (
//     <section class="ser_v_araeea allpages aboutuspages">
//      <div class="container">
//       <div class="al_top_areass">
// 	    <div class="tilss">
// 		 <h2>{aboutDestination.title1}</h2>
// 		</div>
		
// 		<div class="diss_tilss">
// 		 <p>{aboutDestination.description1}</p>
// 		</div>
// 	  </div>
	  
// 	  <div class="row">
// 	   <div class="col-lg-8">
// 	    <div class="ab_mg_bg">
// 		 <img src="images/abt_tp_bg.png" alt="" />
// 		</div>
// 	   </div>
// 	   <div class="col-lg-4">
// 	    <div class="ab_mg_bg">
// 		 <img src="images/abt_tp_sm.png" alt="" />
// 		</div>
// 	   </div>
// 	  </div>
// 	   {loading ? (
//             <Skeleton count={5} height={20} style={{ marginBottom: "10px" }} />
//           ) : (
// 	  <>
	  

		

		

		
	  
	  
// 	  <div class="al_top_areass otherss">
// 	    <div class="tilss">
// 		 <h2>Who we are</h2>
// 		</div>
		
// 		<div class="diss_tilss">
// 		 <p>We’re more than just an experiences platform. We want to create a global community of explorers, hosts, and creators brought together by a shared passion for discovery. Whether you’re craving for a digital detox at a farm, a hands-on cooking class, or an off-the-beaten-path nature walk, we help you find authentic, curated experiences wherever you go.</p>
		 
// 		 <h5>Real People. Real Places. Real Stories.</h5>
		 
// 		 <p>To make extraordinary experiences accessible to everyone — anytime, anywhere. We empower local hosts and experts to share what they love, while giving travelers and locals thechance to explore the world in a more personal, immersive way. We’re not a tour agency...We aren’t here to revolutionise tours...We simply are here</p>
// 		</div>
// 	  </div>
	  
	  
	  
// 	  <div class="ab_item_bx">
//        <div class="allpages">
// 	    <h2 class="text-left">What We Offer</h2>
// 	   </div>
	   
// 	   <div class="row">
// 	    <div class="col-lg-3 col-sm-6">
// 		 <div class="itm_bx_areeaa">
// 		 <div class="itm_bx_btomss">
// 		  <h4>Curated Experiences: </h4>
// 		  <p>From hidden gems to iconic must-dos, every listing on our platform is handpicked or verified for quality and authenticity.</p>
// 		 </div>
// 		 </div>
// 		</div>
		
// 		<div class="col-lg-3 col-sm-6">
// 		 <div class="itm_bx_areeaa">
// 		 <div class="itm_bx_btomss">
// 		  <h4>Local Expertise:</h4>
// 		  <p>We partner with passionate local hosts, guides, and creators who bring deep knowledge and personality to every activity.</p>
// 		 </div>
// 		 </div>
// 		</div>
		
// 		<div class="col-lg-3 col-sm-6">
// 		 <div class="itm_bx_areeaa">
// 		  <div class="itm_bx_btomss">
// 		   <h4>Seamless Booking:</h4>
// 		   <p>Our platform is designed to be simple, secure, and flexible — so you can spend less time planning and more time doing.</p>
// 		  </div>
// 		 </div>
// 		</div>
		
// 		<div class="col-lg-3 col-sm-6">
// 		 <div class="itm_bx_areeaa">
// 		  <div class="itm_bx_btomss">
// 		   <h4>Global Reach, Local Impact:</h4>
// 		   <p>Supporting small businesses and local communities is at the heart of what we do.</p>
// 		  </div>
// 		 </div>
// 		</div>
		
// 	   </div>
//       </div>



//       <div class="al_top_areass otherss">
// 	    <div class="tilss">
// 		 <h2>Why We Started</h2>
// 		</div>
		
// 		<div class="diss_tilss">
// 		 <p>The idea for Weyfarin came from a simple belief: experiences and connection should go beyond the guidebooks. We wanted to create a space where anyone could find truly memorable experiences — and where anyone with a skill or passion could share it with the world.</p>
// 		</div>
// 	  </div>
	  
// 	  <div class="row">
// 	   <div class="col-lg-12">
// 	    <div class="ab_mg_bg">
// 		 <img src="images/abt_btp_bg.png" alt="" />
// 		</div>
// 	   </div>
// 	  </div>	  
// 	  </>
// 		  )}
	 
// 	 </div>
// 	</section> 
//   )
// }
 
// export default AboutUs